<div>
  <form [formGroup]="vinculoForm" id="vinculoForm">
    <div class="row my-2" [ngClass]="statusValidacao ? 'row-cols-3' : 'row-cols-2'">
      <ng-container>
        <div class="col form-group">
          <label nz-checkbox formControlName="flagVinculoPrincipal">Principal</label>
        </div>
      </ng-container>
      <ng-container *ngIf="acao == 'editar' && statusValidacao">
        <div class="col form-group">
          <label for="status" class="form-label">Status Validação: </label>
          <span class="ms-2">{{ statusValidacao }}</span>
        </div>
      </ng-container>
      <ng-container *ngIf="mostrarCampoEstatutario">
        <div class="col form-group text-end">
          <label nz-checkbox formControlName="flagEstatutario">Estatutário</label>
        </div>
      </ng-container>
    </div>
    <div class="row g-3">
      <div class="col-12 col-sm-4 form-group">
        <label for="entidadeId" class="form-label required">Entidade</label>
        <nz-select formControlName="entidadeId" nzShowSearch nzServerSearch nzAllowClear nzPlaceHolder="Digite o nome da entidade" nzSize="large"
          [compareWith]="compareFn" [nzFilterOption]="nzFilterOption" (nzOnSearch)="loadEntidadeCombo($event)" (ngModelChange)="selectCargos($event)">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nome" *ngFor="let item of entidadeList" />
        </nz-select>
      </div>
      <div class="col-12 col-sm-4 form-group" nz-tooltip
        nzTooltipTitle="Digite ao menos as três primeiras letras do nome para iniciar a busca">
        <label for="pessoaId" class="form-label required">Pessoa</label>

        <nz-select id="pessoaId" nzShowSearch nzServerSearch nzPlaceHolder="Digite o nome da pessoa"
          formControlName="pessoaId" [nzShowArrow]="false" [nzFilterOption]="nzFilterOption" nzSize="large"
          [nzAllowClear]="true" [compareWith]="compareFn" (nzOnSearch)="loadEntidadesSuperior($event)"
          (ngModelChange)="carregarCombosPessoasFn($event)">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeCpf" *ngFor="let item of nomePessoaList" />
        </nz-select>

        <!-- <div [ngSwitch]="nomePessoaList.length == 1 && acao == routeActionEnum.Inserir">
          <div *ngSwitchCase="true">
          </div>
          <div *ngSwitchDefault>
            <nz-input-group nzSize="large">
              <input nz-input id="pessoaId" formControlName="pessoaId" placeholder="Digite o nome da pessoa" [disabled]="true" />
            </nz-input-group>
          </div>
        </div> -->
      </div>
      <div class="col-12 col-sm-4 form-group">
        <label for="tipoVinculoId" class="form-label required">Tipo vínculo</label>
        <nz-select formControlName="tipoVinculoId" nzShowSearch nzAllowClear
          [nzPlaceHolder]="vinculo?.nomeTipoVinculo || ' - '" nzSize="large"
          [compareWith]="compareFn" [nzFilterOption]="filtrarOpcaoSemAcento" (nzOpenChange)="seMandadoAddData()">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeTipoVinculo" *ngFor="let item of tipoVinculoList" />
        </nz-select>
      </div>

      <ng-container *ngIf="mostrarInputLotacao()">
        <div class="col-12 col-sm-4 form-group">
          <label for="lotacaoVinculo" class="form-label"
            [class.required]="isFieldRequired('lotacaoVinculo')">Lotação</label>
          <nz-select id="lotacaoVinculo" nzShowSearch nzPlaceHolder="Pesquise a Lotação"
            formControlName="lotacaoVinculo" [nzShowArrow]="false" [nzFilterOption]="filtrarOpcaoSemAcento" nzSize="large"
            [nzAllowClear]="true" [nzMode]="'default'" [nzLoading]="carregandoLotacoes">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nome" *ngFor="let item of lotacaoList" />
          </nz-select>
        </div>
      </ng-container>

      <div class="form-group" [ngClass]="mostrarInputLotacao() ? 'col-12 col-sm-8' : 'col-12'">
        <label for="nomeCargo" class="form-label required">Nome do Cargo</label>
        <nz-input-group nzSize="large">
          <input nz-input id="nomeCargo" formControlName="nomeCargo" placeholder="Informe o nome do Cargo" />
        </nz-input-group>
      </div>

      <div class="col-12 col-sm-4 form-group">
        <label for="cargoReferenciaIds" class="form-label required">Cargo Referencia</label>
        <nz-select id="cargoReferenciaIds" nzShowSearch nzPlaceHolder="Pesquise nomes dos cargos"
          formControlName="cargoReferenciaIds" [nzShowArrow]="true" [nzFilterOption]="filtrarOpcaoSemAcento" nzSize="large"
          [nzAllowClear]="true" [nzMode]="'multiple'" [compareWith]="compareFn" [nzLoading]="carregandoCargos">
          <nz-option [nzValue]="item.id" [nzLabel]="item.nomeCargoReferencia"
            *ngFor="let item of cargoVinculosList"></nz-option>
        </nz-select>
        <nz-alert *ngIf="entidadeSemCargos" nzType="warning"
          nzMessage="Entidade selecionada não possui cargos cadastrados" [nzShowIcon]="true" class="mt-1"></nz-alert>
      </div>


      <!-- <ng-container *ngIf="isHiddenFieldsMandato && isHiddenFieldsPermanente"> -->

      <ng-container
        *ngIf="tipoVinculoIdControl?.value == tipoVinculoEnum.Mandato && isHiddenFieldsPermanenteComissaoSubComissaoGrupoTrabalho && isHiddenFieldsTemporarioComissaoSubComissaoGrupoTrabalho && isHiddenFieldsPermanentOrgao && isHiddenFieldsLotacao && isHiddenFieldsPermanenteAssociados">
        <div class="col-12 col-sm-4 form-group">
          <label for="dataInicioMandato" class="form-label"
            [class.required]="tipoVinculoIdControl?.value == tipoVinculoEnum.Mandato">Início mandato</label>
          <nz-date-picker id="dataInicioMandato" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
            formControlName="dataInicioMandato" (input)="onInputDateChange($event, 'dataInicioMandato')"
            [nzAllowClear]="true"></nz-date-picker>
        </div>
        <div class="col-12 col-sm-4 form-group">
          <label for="dataFimMandato" class="form-label"
            [class.required]="regraComissaoSubcomissaoGrupoTrabalhoMandato()">Fim mandato</label>
          <nz-date-picker id="dataFimMandato" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
            formControlName="dataFimMandato" (ngModelChange)="validaJustificativaMandato()"
            (input)="onInputDateChange($event, 'dataFimMandato')" [nzAllowClear]="true"></nz-date-picker>
        </div>
        <div class="col-12 col-sm-4 form-group" *ngIf="isShowJustificativaFimMandato">
          <label for="justificativaFimMandato" class="form-label"
            [class.required]="isFieldRequired('justificativaFimMandato')">Justificativa para Fim do Mandato</label>
          <nz-input-group nzSize="large">
            <input nz-input id="justificativaFimMandato" formControlName="justificativaFimMandato"
              placeholder="Justificativa alteração data" />
          </nz-input-group>
        </div>

      </ng-container>
      <div class="col-12 col-sm-4 form-group">
        <label for="dataInicioVinculo" class="form-label required">Início vínculo</label>
        <nz-date-picker id="dataInicioVinculo" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
          formControlName="dataInicioVinculo" (input)="onInputDateChange($event, 'dataInicioVinculo')"
          [nzAllowClear]="true"></nz-date-picker>
      </div>
      <div class="col-12 col-sm-4 form-group">
        <label for="dataFimVinculo" class="form-label" [class.required]="isFieldRequired('dataFimVinculo')">Fim
          vínculo</label>
        <nz-date-picker id="dataFimVinculo" [nzFormat]="'dd/MM/YYYY'" [nzSize]="'large'"
          formControlName="dataFimVinculo" (ngModelChange)="validaJustificativaVinculo()"
          (input)="onInputDateChange($event, 'dataFimVinculo')" [nzAllowClear]="true"></nz-date-picker>
      </div>
      <div class="col-12 col-sm-4 form-group" *ngIf="isShowJustificativaFimVinculo">
        <label for="justificativaFimVinculo" class="form-label"
          [class.required]="isFieldRequired('justificativaFimVinculo')">Justificativa para Fim do Vinculo</label>
        <nz-input-group nzSize="large">
          <input nz-input id="justificativaFimVinculo" formControlName="justificativaFimVinculo"
            placeholder="Justificativa alteração data" />
        </nz-input-group>
      </div>


      <ng-container
        *ngIf="isHiddenFieldsMandatoOrgao && isHiddenFieldsPermanentOrgao && isHiddenFieldsLotacao && isHiddenFieldsPermanenteAssociados && isHiddenFieldsTemporarioAssociados && isEntidadeOrgaoEvinculoLocatao">
        <div class="col-12 col-sm-4 form-group">
          <label for="federacaoIndicadoraId" class="form-label"
            [class.required]="isFieldRequired('federacaoIndicadoraId')">Federação que indicou</label>
          <nz-select id="federacaoIndicadoraId" nzShowSearch nzPlaceHolder="Pesquise nome da federação"
            formControlName="federacaoIndicadoraId" [nzShowArrow]="false" [nzFilterOption]="filtrarOpcaoSemAcento"
            nzSize="large" [nzAllowClear]="true" [nzLoading]="carregandoListas">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeFantasia" *ngFor="let item of nomeFederacaoList" />
          </nz-select>
        </div>
      </ng-container>

      <ng-container *ngIf="isHiddenFieldsLotacao && isHiddenFieldsPermanenteAssociados && isHiddenFieldsTemporarioAssociados &&
      isEntidadeOrgaoEvinculoLocatao">
        <div class="col-12 col-sm-4 form-group">
          <label for="entidadeRepresentadaId" class="form-label"
            [class.required]="isFieldRequired('entidadeRepresentadaId') || tipoVinculoIdControl?.value == tipoVinculoEnum.Temporario">
            Entidade representada
          </label>
          <nz-select formControlName="entidadeRepresentadaId" nzShowSearch nzAllowClear
            nzPlaceHolder="Selecione a Entidade Representada" nzSize="large" [compareWith]="compareFn"
            [nzFilterOption]="filtrarOpcaoSemAcento" [nzLoading]="carregandoCombosPessoa">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeFantasia"
              *ngFor="let item of entidadeRepresentanteList" />
          </nz-select>
        </div>
      </ng-container>

      <ng-container
        *ngIf="isHiddenFieldsLotacao && isHiddenFieldsPermanenteAssociados && isHiddenFieldsTemporarioAssociados && isEntidadeOrgaoEvinculoLocatao">

        <div class="col-12 col-sm-4 form-group">
          <label for="cargoPessoaEntidadeRepresentada" class="form-label"
            [class.required]="isFieldRequired('cargoPessoaEntidadeRepresentada')">Cargo pessoa na entidade
            representada</label>
          <nz-select id="cargoPessoaEntidadeRepresentada" nzShowSearch nzAllowClear nzPlaceHolder=" - " nzSize="large"
            [compareWith]="compareFn" [nzFilterOption]="filtrarOpcaoSemAcento" formControlName="cargoPessoaEntidadeRepresentada"
            [nzLoading]="carregandoCombosPessoa">
            <nz-option [nzValue]="item.nome" [nzLabel]="item.nomeCombo"
              *ngFor="let item of cargoPessoaEntidadeRepresentadaList" />
          </nz-select>
        </div>
      </ng-container>


      <!-- <div class="col-12 col-sm-4 form-group" >
        <label for="cargoPessoaEntidadeRepresentada" class="form-label">Cargo pessoa na entidade representada</label>
        <nz-input-group nzSize="large">
          <input nz-input id="cargoPessoaEntidadeRepresentada" formControlName="cargoPessoaEntidadeRepresentada"
            placeholder="nome do cargo vinculado"/>
        </nz-input-group>
      </div> -->
      <ng-container
        *ngIf="isHiddenFieldsMandatoComissaoSubComissaoGrupoTrabalho && isHiddenFieldsPermanenteComissaoSubComissaoGrupoTrabalho && isHiddenFieldsMandatoOrgao && isHiddenFieldsPermanentOrgao && isHiddenFieldsLotacao && isHiddenFieldsPermanenteAssociados && isEntidadeOrgaoEvinculoLocatao">
        <div class="col-12 col-sm-4 form-group">
          <label for="empresaLocacaoTerceiro" class="form-label"
            [class.required]="isFieldRequired('empresaLocacaoTerceiro')">Empresa do temporário</label>
          <nz-input-group nzSize="large">
            <input nz-input id="empresaLocacaoTerceiro" formControlName="empresaLocacaoTerceiro"
              placeholder="Empresa lotação pessoa do vínculo" />
          </nz-input-group>
        </div>
      </ng-container>
      <ng-container *ngIf="isEntidadeOrgaoEvinculoLocatao">
        <div class="col-12 col-sm-4 form-group">
          <label for="vinculoEfetivoSuplenteId" class="form-label"
            [class.required]="isFieldRequired('vinculoEfetivoSuplenteId')">
            Vínculo da pessoa de cargo efetivo
            <span nz-icon nzType="info-circle" nzTheme="outline" nz-popover
              nzPopoverContent="Vínculo da pessoa de cargo efetivo relacionada a pessoa cadastrada com cargo de entidade"></span>
          </label>
          <nz-select id="vinculoEfetivoSuplenteId" nzShowSearch
            nzPlaceHolder="Pesquise nome dos vínculos vigentes" formControlName="vinculoEfetivoSuplenteId"
            [nzShowArrow]="false" [nzFilterOption]="filtrarOpcaoSemAcento" nzSize="large" [compareWith]="compareFn"
            [nzAllowClear]="true">
            <nz-option [nzValue]="item.idVinculo" [nzLabel]="item.nomeConhecido"
              *ngFor="let item of vinculosEfetivosList" />
          </nz-select>
        </div>
      </ng-container>
      <ng-container *ngIf="isHiddenFieldsLotacao && isHiddenAreaAtuacao">
        <div class="col-12 col-sm-4 form-group">
          <label for="areaAtuacaoPessoaEntidadeLotada" class="form-label"
            [class.required]="isFieldRequired('areaAtuacaoPessoaEntidadeLotada')">Área de Atuação</label>
          <nz-select id="areaAtuacaoPessoaEntidadeLotada" nzShowSearch
            nzPlaceHolder="Pesquise a Área de Atuação" formControlName="areaAtuacaoPessoaEntidadeLotada"
            [nzShowArrow]="false" [nzFilterOption]="filtrarOpcaoSemAcento" nzSize="large" [nzAllowClear]="true"
            [nzMode]="'default'" [nzLoading]="carregandoListas">
            <nz-option [nzValue]="item.id" [nzLabel]="item.nomeAreaAtuacao" *ngFor="let item of areaDeAtuacaoList" />
          </nz-select>
        </div>
      </ng-container>
    </div>
  </form>
</div>
